import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { Header, TableStandard } from "ui"
import { useEffect, useState } from "react"
import { splitCamelCase } from "../../../tools/splitCamelCase"
import { CompanyActionHistory, CompanySessionStats } from "../../../__generated__/graphql"
import { Typography, Box } from "@mui/material"
const TABLE_COLUMNS: GridColDef[] = [
    { field: "action", headerName: "Action", flex: 3, sortable: false, resizable: false, disableColumnMenu: true, },
    { field: "count", headerName: "Count", headerAlign: "center", align: "center", flex: 1, sortable: false, resizable: false, disableColumnMenu: true, },
]
type HistoryTypeKey = keyof CompanyActionHistory;
const allowedFields: HistoryTypeKey[] = ["referralsMade", "educationalMaterialsSent"]

const CompanyActionHistoryTable = ({ historyCount }: { historyCount: CompanyActionHistory | null }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = historyCount
                ? allowedFields.map(key => ({
                    id: key,
                    action: splitCamelCase(key),
                    count: historyCount[key]
                }))
                : [];

            return {
                ...prevState,
                columns,
                rows: rows
            }
        })
    }, [historyCount])
    return (
        <TableStandard
            renderToolbar={() => (
                <Header title={`Communication History`} titleSize="p" />
            )}
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            disableBoxShadow
            hideFooter={true}
            loading={false} />
    )
}
export default CompanyActionHistoryTable